import AspectRatioDiv from "./utils/AspectRatioDiv"

type Prop = {
    className? : string,
    imgUrl? : string,
    imgOverlayOpacity? : number,
    bottomChildren? : JSX.Element,
    children? : JSX.Element | JSX.Element[]
}
const Hero = ({
    className = '',
    imgOverlayOpacity = 0,
    imgUrl = 'https://via.placeholder.com/1000.png/888/fff',
    bottomChildren,
    children,
    }:Prop)=>{
    return (
        <div className={className + ' relative '}>
                <AspectRatioDiv className="pt-[100%] md:pt-[60%] lg:pt-[50%] xl:pt-[50%]">
                    <>
                        {( !!imgOverlayOpacity && 
                            <div className="bg-black absolute top-0 left-0 w-full h-full z-[-1]" style={{ opacity : imgOverlayOpacity }}></div>
                        )}
                        <img src={imgUrl} className="w-full absolute top-0 left-0 object-cover z-[-2] object-center h-full" alt="" />
                        {children}
                    </>
                </AspectRatioDiv>
            {bottomChildren}
        </div>
    )
}

export default Hero;